import React, { useEffect, useContext } from 'react';
import ReactPaginate from 'react-paginate';
import { SearchContext } from '../../context/Search';

const Pagination = () => {
  const { offset, setOffset, totalCount, limit, setForcePage, forcePage, setPageCount, pageCount } = useContext(SearchContext);

  useEffect(() => {
    setPageCount(Math.ceil(totalCount / limit));
    setForcePage(Math.ceil(offset / limit))
  }, [offset, limit, pageCount, totalCount])

  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    setOffset(limit * selectedPage)
    setForcePage(selectedPage)
    window.scroll({top: 0, left: 0, behavior: 'smooth' })
  }

  return (
    <ReactPaginate
      previousLabel={"<"}
      nextLabel={">"}
      breakLabel={"..."}
      forcePage={forcePage}
      breakClassName={"break-me"}
      pageCount={pageCount}
      marginPagesDisplayed={1}
      pageRangeDisplayed={2}
      onPageChange={handlePageClick}
      containerClassName={"pagination"}
      subContainerClassName={"pages pagination"}
      activeClassName={"active"}
    />
  )
}

export default Pagination;